module.exports = __webpack_public_path__ + "img/zola.a1115560.jpg";